// extracted by mini-css-extract-plugin
export default {"TrayGridLabelContainer":"TrayLabel_TrayGridLabelContainer__yG13s","TrayGridLabel":"TrayLabel_TrayGridLabel__+P4CC"};